// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adf-viewer__unknown-format-view {
  height: 90vh;
  text-align: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
}

.goBack {
  width: 300px;
  margin: 25px auto;
}`, "",{"version":3,"sources":["webpack://./src/app/viewer/components/unknown-format/unknown-format.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;AACF","sourcesContent":[".adf-viewer__unknown-format-view {\r\n  height: 90vh;\r\n  text-align: center;\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.goBack {\r\n  width: 300px;\r\n  margin: 25px auto;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
